import { Box, Stack } from "@mui/material";
import { CustomTextView } from "../../../component/CustomTextView";
import { COLOR_LIGHT_GRAY, COLOR_VERY_LIGHT_GRAY, COLOR_WHITE } from "../../../../data/colors/Colors";
import { useEffect } from "react";
import { UserInfoViewModel } from "./UserInfoViewModel";
import { providePlayerGetCurrentInfoUseCase } from "../../../di/UseCasesModule";
import { useTranslation } from "react-i18next";
import { Player, SchoolType } from "../../../../domain/model/User";
import { STORAGE_KEYS } from "../../../../data/constant/Constants";

export function UserAvatarView({
  onFetchPlayer,
}: {
  onFetchPlayer: (p: Player) => void;
}) {
  const viewModel = UserInfoViewModel(providePlayerGetCurrentInfoUseCase());
  const player = viewModel.player;

  const { t } = useTranslation();

  useEffect(() => {
    if (player) onFetchPlayer(player);
  }, [player]);

  useEffect(() => {
    window.addEventListener(
      STORAGE_KEYS.SHOULD_FETCH_PLAYER_AGAIN,
      viewModel.getCurrentInfo,
    );

    return () => {
      window.removeEventListener(
        STORAGE_KEYS.SHOULD_FETCH_PLAYER_AGAIN,
        viewModel.getCurrentInfo,
      );
    };
  }, []);

  return (
    <Stack alignItems={"center"} width={"100%"} gap={2}>
      {player ? (
        <Stack alignItems={"center"} width={"100%"}>
          <CustomTextView
            text={
              player.schoolType == SchoolType.PRIMARY
                ? t("primary_school")
                : player.schoolType == SchoolType.MIDDLE_AND_HIGH_SCHOOL
                  ? t("secondary_school")
                  : ""
            }
            variant="body1"
            textColor={COLOR_WHITE}
            textAlign="center"
            fontWeight="bold"
          />
          <CustomTextView
            text={`ID#${player.user?._id}`}
            variant="caption"
            textColor={COLOR_VERY_LIGHT_GRAY}
            textAlign="center"
          />
        </Stack>
      ) : (
        <CustomTextView
          text={t("loading")}
          variant="body1"
          textColor={COLOR_WHITE}
          textAlign="center"
          fontWeight="bold"
        />
      )}
    </Stack>
  );
}
